const ROUTE_PREFIX_WEBAPP = 'secure/next';

const ROUTE_PREFIX_ARRANGE = 'arrange';

const ROUTE_PREFIX_ARRANGE2 = 'arrange2';

const ROUTE_PREFIXES = [
  ROUTE_PREFIX_WEBAPP,
  ROUTE_PREFIX_ARRANGE,
  ROUTE_PREFIX_ARRANGE2,
];

export const baseHrefFactory = (): string => {
  const currentLocation = window.location.pathname;

  const matchingPrefix = ROUTE_PREFIXES.filter((route) => {
    return (
      currentLocation.startsWith(`/${route}/`) ||
      currentLocation === `/${route}`
    );
  });

  if (matchingPrefix.length > 0) {
    return `/${matchingPrefix[0]}`;
  }

  return '/';
};
